import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

export default function DraggableOccasionOptions({
    options=[],
    onRemove=() => {},
    onDragEnd=() => {},
}) {
    const handleOnDragEnd = (result) => {
        if (!result.destination) { return }
        const items = [...options]
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)
        onDragEnd(items)
    }

    return !!options && Array.isArray(options) && options.length > 0 && (
        <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="draggable-options">
                {
                    (provided) => (
                        <div
                            ref={provided.innerRef}
                            className="draggable-options"
                            {...provided.droppableProps}
                        >
                            {
                                options.map((text, index) => (
                                        <Draggable
                                            key={`${text}-${index}`}
                                            draggableId={`occasion-${index}`}
                                            index={index}
                                        >
                                            {
                                                (provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className="row py-1"
                                                    >
                                                        <div className="col-8 col-md-10">
                                                            <i className="fas fa-bars text-muted mr-3" />
                                                            { text }
                                                        </div>
                                                        <div className="col-4 col-md-2 text-right">
                                                            <button
                                                                children='Remove'
                                                                type='button'
                                                                className='btn btn-link text-danger'
                                                                onClick={() => onRemove(index)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Draggable>
                                    ))
                            }
                            {provided.placeholder}
                        </div>
                    )
                }
            </Droppable>
        </DragDropContext>
    )
}
